import { render, staticRenderFns } from "./blockPartnerDialog.vue?vue&type=template&id=7db57156&scoped=true"
import script from "./blockPartnerDialog.vue?vue&type=script&lang=ts"
export * from "./blockPartnerDialog.vue?vue&type=script&lang=ts"
import style0 from "./blockPartnerDialog.vue?vue&type=style&index=0&id=7db57156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db57156",
  null
  
)

export default component.exports